import { Logger } from '../../packages/logger/src/Logger';

let graphDirectoryForbidden = false;

/** True after Microsoft Graph directory/contacts APIs return 403 for this session. */
export function isGraphDirectoryForbidden(): boolean {
  return graphDirectoryForbidden;
}

/** Record that Graph directory search is not permitted; skip further Graph directory calls. */
export function markGraphDirectoryForbidden(context?: string): void {
  if (!graphDirectoryForbidden) {
    graphDirectoryForbidden = true;
    Logger.info(
      `[Graph] Directory/contacts API forbidden (403); DSS-only for remainder of session${
        context ? ` (${context})` : ''
      }`
    );
  }
}

/** Test-only reset. */
export function resetGraphDirectoryForbiddenForTests(): void {
  graphDirectoryForbidden = false;
}

export function isGraphForbiddenStatus(status?: number): boolean {
  return status === 403;
}

export function isGraphForbiddenError(error: unknown): boolean {
  const err = error as { response?: { status?: number }; status?: number; statusCode?: number };
  const status = err?.response?.status ?? err?.status ?? err?.statusCode;
  return status === 403;
}
